<div *ngIf="peerConnection">
  <div id="peer-connection-general-information">
    <div class="map-summary-item-container">
      <span class="map-summary-item-field">Name:</span>
      <span class="map-summary-item-value" [title]="peerConnection.name">{{ peerConnection.name }}</span>
    </div>

    <div class="map-summary-item-container">
      <span class="map-summary-item-field">Administrative State:</span>
      <span class="map-summary-item-value"
            [title]="generateAdministrativeStateLabel()">{{ generateAdministrativeStateLabel() }}</span>
    </div>

    <div class="map-summary-item-container">
      <span class="map-summary-item-field">Operative State:</span>
      <span class="map-summary-item-value" [title]="peerConnection.operState">{{ peerConnection.operState }}</span>
    </div>

    <div class="map-summary-item-container">
      <span class="map-summary-item-field">IPGroup Name:</span>
      <span class="map-summary-item-value" [title]="peerConnection.nativeName">{{ peerConnection.nativeName }}</span>
    </div>

    <div class="map-summary-item-container">
      <span class="map-summary-item-field" *ngIf="peerConnection.peerConnectionNodeType === 'Virtual'">TGRP:</span>
      <span class="map-summary-item-value" *ngIf="peerConnection.peerConnectionNodeType === 'Virtual'"
            [title]="peerConnection.tgrp">{{ peerConnection.tgrp }}</span>
    </div>

    <div *ngIf="isQualityEnabled">
      <div class="map-summary-item-container">
        <span class="map-summary-item-field">Quality:</span>
        <span class="map-summary-item-value" [title]="peerConnection.result">{{ peerConnection.result }}</span>
      </div>

      <div class="map-summary-item-container">
        <span class="map-summary-item-field">MOS:</span>
        <span class="map-summary-item-value"
              [title]="peerConnection.quality.MOS.measurement == -1 ? 'UNKNOWN' : peerConnection.quality.MOS.measurement">
          {{ peerConnection.quality.MOS.measurement == -1 ? 'UNKNOWN' : peerConnection.quality.MOS.measurement }}
        </span>
      </div>

      <div class="map-summary-item-container">
        <span class="map-summary-item-field">ASR:</span>
        <span class="map-summary-item-value"
              [title]="peerConnection.quality.ASR.measurement == -1 ? 'UNKNOWN' : peerConnection.quality.ASR.measurement">
          {{ peerConnection.quality.ASR.measurement == -1 ? 'UNKNOWN' : peerConnection.quality.ASR.measurement }}
        </span>
      </div>
    </div>

    <div *ngIf="peerConnection.cacProfileId">
      <div class="map-summary-item-container">
        <span class="map-summary-item-field">CAC Profile:</span>
        <span class="map-summary-item-value"
              [title]="peerConnection.cacProfileName">{{ peerConnection.cacProfileName }}</span>
      </div>
      <div class="map-summary-item-container">
        <span class="map-summary-item-field">CAC State:</span>
        <span class="map-summary-item-value" [title]="peerConnection.cacState">{{ peerConnection.cacState }}</span>
      </div>
    </div>

    <div class="map-summary-item-container">
      <span class="map-summary-item-field">Weight:</span>
      <span class="map-summary-item-value" [title]="peerConnection.weight">{{ peerConnection.weight }}</span>
    </div>

    <div class="map-summary-item-container">
      <span class="map-summary-item-field">Node name:</span>
      <span class="map-summary-item-value" [title]="peerConnection.nodeName">{{ peerConnection.nodeName }}</span>
    </div>

    <div class="map-summary-item-container" *ngIf="topologyGroups">
      <span class="map-summary-item-field">Resource Groups:</span>
      <span class="map-summary-item-value" [title]="topologyGroups">{{ topologyGroups }}</span>
    </div>

    <div class="map-summary-item-container">
      <span class="map-summary-item-field">Peer connection type:</span>
      <span class="map-summary-item-value"
            [title]="peerConnection.peerConnectionNodeType">{{ peerConnection.peerConnectionNodeType }}</span>
    </div>

    <div class="map-summary-item-container" *ngIf="peerConnection.sipReasonGroupId">
      <span class="map-summary-item-field">Alternative SIP reason:</span>
      <span class="map-summary-item-value"
            [title]="peerConnection.sipReasonGroupName">{{ peerConnection.sipReasonGroupName }}</span>
    </div>

    <ng-container *ngIf="peerConnection.callsQuotaId">
      <div class="map-summary-item-container">
        <span class="map-summary-item-field">Calls quota:</span>
      </div>

      <div class="map-summary-section">
        <div class="map-summary-item-container">
          <span class="map-summary-item-field">Quota name:</span>
          <span class="map-summary-item-value"
                [title]="peerConnection.callsQuotaName">{{ peerConnection.callsQuotaName }}</span>
        </div>

        <div class="map-summary-item-container">
          <span class="map-summary-item-field">Calls duration (minutes):</span>
          <span class="map-summary-item-value"
                [title]="peerConnection.callsDuration || '0'">{{ peerConnection.callsDuration || '0' }}</span>
        </div>

        <div class="map-summary-item-container">
          <span class="map-summary-item-field">Outgoing calls:</span>
          <span class="map-summary-item-value">
            <i class="fa fa-check summary-value-green" *ngIf="peerConnection.quotaState === 'UNBLOCK'"></i>
            <i class="fa fa-times summary-value-red" *ngIf="peerConnection.quotaState === 'BLOCK_OUTGOING'"></i>
          </span>
        </div>

        <div class="map-summary-item-container">
          <span class="map-summary-item-field">Warning threshold reached:</span>
          <span class="map-summary-item-value">
            <span class="summary-value-red" *ngIf="peerConnection.quotaWarningReached">Yes</span>
            <span class="summary-value-green" *ngIf="!peerConnection.quotaWarningReached">No</span>
          </span>
        </div>

        <div class="map-summary-item-container">
          <span class="map-summary-item-field">Quota reached:</span>
          <span class="map-summary-item-value">
            <span class="summary-value-red" *ngIf="peerConnection.quotaLimitReached">Yes</span>
            <span class="summary-value-green" *ngIf="!peerConnection.quotaLimitReached">No</span>
          </span>
        </div>
      </div>
    </ng-container>


    <ng-container *ngIf="peerConnection.shortCallsProfileId">

      <div class="map-summary-item-container">
        <span class="map-summary-item-container">Short Calls Profile:</span>
      </div>
      <div class="map-summary-section">

      <div class="map-summary-item-container">
        <span class="map-summary-item-field">Profile Name:</span>
        <span class="map-summary-item-value"
              [title]="peerConnection.shortCallsProfileName">{{ peerConnection.shortCallsProfileName }}</span>
      </div>

      <div class="map-summary-item-container">
        <span class="map-summary-item-field">Min. calls per day:</span>
        <span class="map-summary-item-value"
              [title]="peerConnection.shortCallsMinDailyTotalCalls">{{ peerConnection.shortCallsMinDailyTotalCalls }}</span>

      </div>

        <div class="map-summary-item-container">
          <span class="map-summary-item-field">Current daily calls:</span>
          <span class="map-summary-item-value"
                [title]="peerConnection.shortCallsCurrentTotalCalls">{{ peerConnection.shortCallsCurrentTotalCalls }}
            ({{ (peerConnection.shortCallsMinDailyTotalCalls - peerConnection.shortCallsCurrentTotalCalls) < 0 ? 'Calls limit exceeded' : (peerConnection.shortCallsMinDailyTotalCalls - peerConnection.shortCallsCurrentTotalCalls + ' left') }})
          </span>
        </div>

      <div class="map-summary-item-container">
        <span class="map-summary-item-field">Current Short Call percentage:</span>
        <span class="map-summary-item-value" [title]="peerConnection.shortCallsPercentage">{{peerConnection.shortCallsPercentage}}%</span>
      </div>

        <div class="map-summary-item-container">
          <span class="map-summary-item-field">Thresholds reached:</span>
          <span class="map-summary-item-value">
		            <span class="summary-value-red" *ngIf="peerConnection.shortCallsLimitReached">Yes</span>
            <span class="summary-value-green" *ngIf="!peerConnection.shortCallsLimitReached">No</span>
  </span>



        </div>
        <!-- Display Routing Action only if all thresholds are reached -->
        <div class="map-summary-item-container" *ngIf="peerConnection.shortCallsLimitReached">
          <span class="map-summary-item-field">Action:</span>
          <span class="map-summary-item-value" [ngSwitch]="peerConnection.shortCallsState">
            <span *ngSwitchCase="'LOCKED_FOR_OUTGOING'">
              Lock peer connection for new outgoing calls
            </span>
            <span *ngSwitchCase="'DROP_OUTGOING'">
              Drop new outgoing calls
            </span>
            <span *ngSwitchCase="'UNBLOCK'">
              Alarm only
            </span>
            <span *ngSwitchDefault>
              Unknown
            </span>
        </span>
        </div>




      </div>
    </ng-container>

  </div>
  <div id="peer-connection-summary-charts">
    <div id="routing-attempt-chart-container">
      <div class="chart-expand-compress-buttons">
        <button class="fa fa-expand" (click)="openRoutingAttemptsChartDialog()"></button>
      </div>
      <div class="chart-summary-container">
        <arm-highchart [options]="optionsForRoutingAttempts"></arm-highchart>
      </div>
    </div>

    <div id="unsuccessful-routes-chart-container">
      <div class="chart-expand-compress-buttons">
        <button class="fa fa-expand" (click)="openUnsuccessfulRoutesChartDialog()"></button>
      </div>
      <div class="chart-summary-container">
        <arm-highchart [options]="optionsForUnsuccessfulRoutes"></arm-highchart>
      </div>
    </div>

    <div id="calls-chart-container">
      <div class="chart-expand-compress-buttons">
        <button class="fa fa-expand" (click)="openCallsChartDialog()"></button>
      </div>
      <div class="chart-summary-container">
        <arm-highchart [options]="optionsForCalls"></arm-highchart>
      </div>
    </div>


  </div>
</div>
